/* Helpers de moeda (28-13). Persistência em cents (int); display locale-aware via
   Intl. `parseCurrencyToCents` aceita "1.234,56" (BR) e "1234.56" (US): remove
   separadores de milhar e usa o último separador como decimal. `Math.round` evita
   erro de ponto-flutuante (19.99 → 1999, não 1998.9999). */

export function formatCents(cents: number, currency: string): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format(cents / 100);
}

export function parseCurrencyToCents(input: string): number {
  const cleaned = input.replace(/[^\d.,]/g, '');
  if (cleaned.length === 0) return 0;
  const lastComma = cleaned.lastIndexOf(',');
  const lastDot = cleaned.lastIndexOf('.');
  const decimalSep = lastComma > lastDot ? ',' : lastDot > lastComma ? '.' : '';
  let normalized: string;
  if (decimalSep === '') {
    normalized = cleaned.replace(/[.,]/g, '');
  } else {
    const other = decimalSep === ',' ? '.' : ',';
    normalized = cleaned.split(other).join('').replace(decimalSep, '.');
  }
  const value = Number(normalized);
  if (!Number.isFinite(value) || value < 0) return 0;
  return Math.round(value * 100);
}
